export const AuthHeader = ({
    description,
    title,
}: {
    description?: string,
    title: string,
}) => (
    <>
        <h1
            className="
                text-gradient
                mb-2
                text-2xl
                font-bold
                sm:text-3xl
            "
        >
            {title}
        </h1>
        {description && <p className="text-gradient mb-8 font-medium">{description}</p>}
    </>
);
